import MessageManager from './messageManager'
import ApiClient from '@/domain/core/utils/apiClient'
import client_core from '@/services/clients/client_core'

const TASK_TOPIC = 'pica/tasks/{taskId}/'
const timers = new Map()
const client = new ApiClient(client_core)

function poll(taskId) {
    return client.get(`/dashboard/v2/long-tasks/${taskId}/`)
}

export default {
    observe(taskId, { onMessage, pollFn, pollInterval = 30000 }) {
        MessageManager.on(TASK_TOPIC, (data, event) => onMessage({ ...data, type: event }, 'mqtt'), `task-${taskId}`, { taskId })

        if (pollInterval > 0) {
            const fn = pollFn || (() => poll(taskId))
            const doPoll = async () => {
                if (!timers.has(taskId)) return
                try { onMessage(await fn(), 'poll') }
                catch { /* next poll will retry */ }
            }
            // First poll after 1s (backend may complete before MQTT arrives), then regular interval
            const initialTimer = setTimeout(() => {
                doPoll()
                timers.set(taskId, setInterval(doPoll, pollInterval))
            }, 1000)
            timers.set(taskId, initialTimer)
        }
    },
    unobserve(taskId) {
        if (timers.has(taskId)) {
            clearTimeout(timers.get(taskId))
            clearInterval(timers.get(taskId))
            timers.delete(taskId)
        }
        MessageManager.off(`task-${taskId}`)
    }
}
